


































import Vue from 'vue'
import Language from '../Language/Language.vue'
import firebase from 'firebase/app'
import 'firebase/auth'

export default Vue.extend({
  name: 'User',
  components: {
    Language
  },
  methods: {
    signOut (): void {
      firebase.auth().signOut()
    }
  }
})
